// SPDX-FileCopyrightText: 2024 LiveKit, Inc.
//
// SPDX-License-Identifier: Apache-2.0
export const ATTRIBUTE_TRANSCRIPTION_TRACK_ID = 'lk.transcribed_track_id';
export const ATTRIBUTE_TRANSCRIPTION_FINAL = 'lk.transcription_final';
export const TOPIC_TRANSCRIPTION = 'lk.transcription';
export const ATTRIBUTE_TRANSCRIPTION_SEGMENT_ID = 'lk.segment_id';
/**
 * The expression (delivery/emotion) the agent used for a transcription segment, surfaced
 * so the frontend can react to it, when expressive markup is stripped from the transcript.
 * The value is a JSON object `{"expression": ..., "mood": ...}` carrying the segment's
 * leading expression — the `<expression>` tag for Inworld/xAI or the `<emotion>` tag for
 * Cartesia — plus the mood it normalizes to, e.g.
 * `{"expression":"speak happy","mood":"happy"}`. A JSON object (rather than a bare string)
 * so the shape can gain fields later without breaking parsers.
 */
export const ATTRIBUTE_TRANSCRIPTION_EXPRESSION = 'lk.expression';
export const ATTRIBUTE_PUBLISH_ON_BEHALF = 'lk.publish_on_behalf';
export const TOPIC_CHAT = 'lk.chat';

export const ATTRIBUTE_AGENT_STATE = 'lk.agent.state';
export const ATTRIBUTE_AGENT_NAME = 'lk.agent.name';

export const TOPIC_CLIENT_EVENTS = 'lk.agent.events';
export const RPC_GET_SESSION_STATE = 'lk.agent.get_session_state';
export const RPC_GET_CHAT_HISTORY = 'lk.agent.get_chat_history';
export const RPC_GET_AGENT_INFO = 'lk.agent.get_agent_info';
export const RPC_SEND_MESSAGE = 'lk.agent.send_message';
export const TOPIC_AGENT_REQUEST = 'lk.agent.request';
export const TOPIC_AGENT_RESPONSE = 'lk.agent.response';
export const TOPIC_SESSION_MESSAGES = 'lk.agent.session';
